import {useTranslations} from 'next-intl';

export default function SidebarSearch({ onSearch, searchInput }) {
  const t = useTranslations('catalog');

  return (
    <div className="widget ltn__search-widget">
      <h4 className="ltn__widget-title ltn__widget-title-border">
        {t('searchProducts')}
      </h4>
      <form
          style={{ position: "relative" }}
          onSubmit={onSearch}
      >
        <input
            type="text"
            name="search"
            placeholder={t('searchYourKeyword')}
            defaultValue={searchInput}
            // onChange={(e) => handleSearchString(e.target.value)}
        />
        <button type="submit">
          <i className="fas fa-search"></i>
        </button>
      </form>
    </div>
  );
};
